<template>
    <div class="wrap-dashboard">
        <div class="title-page">PC Inventory</div>
        <div class="content">
            
            <div class="d-flex justify-content-between mb-3 align-items-center">
                
                <div class="filter-search">
                    <input type="text" class="form-input" placeholder="Cari nama peserta atau HIN.." v-model="paramsUrl.keyword" @keyup="filterSearch" />
                    <img src="@/assets/icon_cms/search.svg" alt="" class="icon-input" />
                </div>
                <div class="view-perpages">
                    <select v-model="paramsUrl.perPage" @change="showDataRow">
                        <option value="10">10</option>
                        <option value="50">50</option>
                        <option value="100">100</option>
                    </select>
                    <span>&nbsp;Data per page</span>
                </div>
            </div>

            <table>
                <thead>
                    <tr id="top">
                        <th scope="col">No</th>
                        <th scope="col">Broker Name</th>
                        <th scope="col">
                            <div class="d-flex justify-content-between align-items-center">
                                <span>Participant Name</span>
                                <span @click="filterSortBy('fullname')">
                                    <IconSortTable class="icon-sort" :sort-order="paramsUrl.sortBy === 'fullname' ? paramsUrl.order : null"></IconSortTable>
                                </span>
                            </div>
                        </th>
                        <th scope="col">
                            <div class="d-flex justify-content-between align-items-center">
                                <span>HIN</span>
                                <span @click="filterSortBy('hin')">
                                    <icon-sort-table class="icon-sort" :sort-order="paramsUrl.sortBy === 'hin' ? paramsUrl.order : null"></icon-sort-table>
                                </span>
                            </div>
                        </th>
                        <th scope="col">Gold Balance (Gr)</th>
                        <th scope="col">Gold Current Value(USD)</th>
                        <th scope="col">Gold Current Value(IDR)</th>
                        <th scope="col">Actions</th>
                    </tr>
                </thead>
                <tbody v-if="isloadData">
                    <tr>
                        <td colspan="10">
                            <b-spinner label="Loading..."></b-spinner>
                        </td>
                    </tr>
                </tbody>
                <tbody v-else>
                    <tr v-for="(data, i) in userDatas" :key="i" v-show="userDatas.length != 0">
                        <td>{{ (paramsUrl.currentPage - 1) * paramsUrl.perPage + (i + 1) }}</td>
                        <td>{{ data.broker_code == 'BEI03002' || data.broker_code == 'BEI03001' ? 'ABI Commodity Futures' : '-' }}</td>
                        <td>{{ formatCapitalize(data.fullname) }}</td>
                        <td>{{ data.trade_account.hin, }}</td>
                        <td>
                            <b-spinner v-if="isLoadingRow[i]" small></b-spinner>
                            <span v-else>{{ dataTradeAccount[i] ? dataTradeAccount[i].gram  : '-'}}</span>
                        </td>
                        <td>
                            <b-spinner v-if="isLoadingRow[i]" small></b-spinner>
                            <span v-else>{{ dataTradeAccount[i] ? dataTradeAccount[i].price_usd : '-' }}</span>
                        </td>
                        <td>
                            <b-spinner v-if="isLoadingRow[i]" small></b-spinner>
                            <span v-else>{{ dataTradeAccount[i] ? dataTradeAccount[i].price_idr : '-'}}</span>
                        </td>
                        <td>
                            <router-link :to="`/user-participant/${data.trade_account.account_id}_${data.trade_account.hin}_${data.fullname}_${ dataTradeAccount[i] ?  dataTradeAccount[i].gram : ''}`">
                                <b-button class="btn btn-info btn-sm">Detail</b-button>
                            </router-link>
                        </td>
                    </tr>
                    <tr v-show="userDatas.length == 0">
                        <td colspan="10">No Data Available</td>
                    </tr>
                </tbody>
            </table>
            <div class="d-flex justify-content-end mt-3">
                <b-pagination
                    v-model="paramsUrl.currentPage"
                    :total-rows="totalData"
                    :per-page="paramsUrl.perPage"
                    @change="handlePageChange"
                    aria-controls="new-table"
                    first-number
                    last-number
                    v-show="totalData > paramsUrl.perPage"
                ></b-pagination>
            </div>
        </div>
    </div>
</template>

<script>
import axios from "axios";
import IconSortTable from "../../../assets/IconSortTable.vue";
export default {
    components: { IconSortTable },
    data() {
        return {
            loadingData: false,
            today: "",
            form: {
                startDate: "",
                endDate: "",
            },
            revenue: "",
            imgRevenue: null,
            role: "",
            displayCategory: false,
            selectedId: null,
            dataBalance: [],
            dataGram: [],
            dataUSDValue : [],
            dataIDRValue : [],
            price: null,
            priceEndDay: null,
            // totalData: null,
            isLoaderBalance: false,
            paramsUrl: {
                currentPage: 1,
                perPage: 10,
                keyWord: "",
                broker: [],
                bank: [],
                sortBy: "",
                order: "",
                role: 'PC',
            },
            dataListBank: "",
            dataListBroker: "",
            timeOut: setTimeout(() => {}, 0),
            totalBalance: "",
            dataSummary: [],
            dataTradeAccount: [],
            isLoadingRow: [],
        };
    },
    mounted() {

        axios.get("v2/clearing/admin/get/total_balance").then((res) => {
            this.totalBalance = res.data.data.body;
        });

        // axios.get('/v2/clearing/admin/get/end_day_price').then(resEndDay=>{
        //             this.priceEndDay = resEndDay.data.data.body
        //         })
        
        this.getDataSummary(this.paramsUrl.currentPage)
        // this.getData(this.paramsUrl)
        this.newGetData(this.paramsUrl)
        
    },
    methods: {
        getDataSummary(currentPage){
            let offset = (currentPage -1 ) * this.paramsUrl.perPage
            let url;
            let role = sessionStorage.getItem("role");
            
            if (role == 2 || role == 3) {
                url = "v2/clearing/admin/abx/get/list/summary_inventory?startDate&endDate&limit&offset" + offset + "&type=onexchange";
            } else {
                url = "v2/clearing/admin/get/list/summary_inventory?startDate&endDate&limit&offset=" + offset + "&type=onexchange";
            }
            axios.get(url).then(res=>{
                this.dataSummary = res.data.data.body
            })

        },
        async getPrice(){
            try{
                const price = await axios.get('/v2/clearing/admin/get/price')
                const priceDay = price.data.data.body

                if(priceDay.price !==0 && priceDay.price_idr !== 0){
                    return priceDay
                }

                const responesEndDay = await axios.get('/v2/clearing/admin/get/end_day_price')
                const priceEndDay = responesEndDay.data.data.body
                return priceEndDay
            } catch(err){
                return {price: 0, price_idr: 0}
            }
        },

        async newGetData(paramsUrl){
            // this.loadingData = true
            try {
                const responseDataTrade = await this.$store.dispatch("getTradeAccount", paramsUrl)
                const priceUsed = await this.getPrice()
                await Promise.all( 
                    responseDataTrade.map(async (item, i) =>
                    {
                        this.$set(this.isLoadingRow, i, true)
                        try{
                            const dataGram = await axios.get('/v2/clearing/admin/get/total_gold?account_id=' + item.trade_account.account_id)
                            const totalGram = dataGram.data.data.body.total_gram
                            const priceUSD = totalGram * priceUsed.price
                            const priceIDR = totalGram * priceUsed.price_idr

                            this.$set(this.dataTradeAccount, i, {
                                gram: this.formatIDR(totalGram),
                                price_usd: this.formatPrice(priceUSD),
                                price_idr: this.formatPrice(priceIDR)
                            })
                        } catch(err){
                            this.$set(this.dataTradeAccount, i, {
                                gram: '-',
                                price_usd: '-',
                                price_idr: '-'
                            })
                        } finally {
                            this.$set(this.isLoadingRow, i, false)
                        }
                    })
                )

                // this.loadingData = false
            } catch (err){
                // this.loadingData = false
                console.log(err)
            } 
        },
        getData(paramsUrl){
            this.$store.dispatch("getTradeAccount", paramsUrl).then((res) => {
                for (let i = 0; i < res.length; i++) {
                    this.$set(this.dataGram, i, "loading");
                    this.$set(this.dataBalance, i, "loading");
                    this.$set(this.dataUSDValue, i, "loading");
                    this.$set(this.dataIDRValue, i, "loading");

                    axios.get("/v2/clearing/admin/get/total_gold?account_id=" + res[i].trade_account.account_id).then((resGram) => {
                        let totalGram = resGram.data.data.body.total_gram;
                        let priceUSD = null
                        let priceIDR = null
                        if(this.price.price != 0 && this.price.price_idr != 0){
                            priceUSD = totalGram ? totalGram * this.price.price : 0
                            priceIDR = totalGram ? totalGram * this.price.price_idr : 0
                        } else {
                            priceUSD = totalGram ? totalGram * this.priceEndDay.price : 0
                            priceIDR = totalGram ? totalGram * this.priceEndDay.price_idr : 0
                        }
                        this.$set(this.dataUSDValue, i, this.formatPrice(priceUSD));
                        this.$set(this.dataIDRValue, i, this.formatPrice(priceIDR));
                        this.$set(this.dataGram, i, this.formatIDR(totalGram));
                    }).catch(()=>{
                        this.$set(this.dataUSDValue, i, '-');
                        this.$set(this.dataIDRValue, i, '-');
                        this.$set(this.dataGram, i, '-')
                    })
                }
            });
        },
        formatCapitalize(value) {
            let string = value.toLowerCase();
            return string.replace(/(^\w{1})|(\s+\w{1})/g, (letter) => letter.toUpperCase());
        },
        filterByBank() {
            this.getData(this.paramsUrl)
        },
        filterByBroker() {
            this.getData(this.paramsUrl)
        },
        filterOrder() {
            this.getData(this.paramsUrl)
        },
        filterSortBy(labelSort) {
            this.paramsUrl.currentPage = 1
            this.paramsUrl.sortBy = labelSort
            this.paramsUrl.order = this.paramsUrl.order == 'asc' ? 'desc' : 'asc'
            // this.getData(this.paramsUrl)
            this.newGetData(this.paramsUrl)
        },
        filterSearch(event) {
            this.paramsUrl.currentPage = 1
            this.paramsUrl.keyWord = event.target.value;
            clearTimeout(this.timeOut);
            this.timeOut = setTimeout(() => {
                // this.getData(this.paramsUrl)
                this.newGetData(this.paramsUrl)
            }, 800);
        },
        resetFilter() {
            this.paramsUrl.bank = [];
            this.paramsUrl.broker = [];
            this.getData(this.paramsUrl)

        },
        resetSortBy() {
            this.paramsUrl.sortBy = "";
            // this.getData(this.paramsUrl)
            this.newGetData(this.paramsUrl)

        },
        handlePageChange(value) {
            this.paramsUrl.currentPage = value;
            // this.getData(this.paramsUrl)
            this.newGetData(this.paramsUrl)

            window.scrollTo({ top: 0, behavior: "smooth" });
        },
        showDataRow() {
            this.paramsUrl.currentPage = 1;
            // this.getData(this.paramsUrl)
            this.newGetData(this.paramsUrl)

        },
        formatPrice(value) {
            return new Intl.NumberFormat("en-US", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            }).format(value);
        },
        formatIDR(value) {
            let val = (value / 1).toFixed(2).replace(",", ".");
            return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        },
        select(itemId) {
            this.selectedId = itemId;
            this.displayCategory = !this.displayCategory;
        },
        selectedDropdown(value, img) {
            this.revenue = value;
            this.imgRevenue = img;
        },
    },
    computed: {
        userDatas() {
            // return this.$store.state.cashModule.tradeAccountData;
            return this.$store.getters.getDataTrade;
        },
        totalData() {
            return this.$store.state.bappebtiModule.totalTradeAccountData;
        },
        isloadData() {
            return this.$store.state.bappebtiModule.isLoading;
        },

        countBadge() {
            let nominal = this.paramsUrl.bank.length + this.paramsUrl.broker.length;
            return nominal;
        },
    },
};

</script>

<style scoped>
/*.wrap-dashboard {
  min-height: 100vh;
  margin: 0;
  display: grid;
  grid-template-rows: auto 1fr auto;
}*/

.filter-sort {
    display: flex;
    gap: 1rem;
}

.filter-search {
    width: 25%;
    position: relative;
}

.icon-input {
    position: absolute;
    top: 0.65rem;
    right: 0.65rem;
}

.select-filter {
    border: solid 1px #ddd;
    padding: 0.5rem 0.75rem;
    border-radius: 0.25rem;
    font-size: 13px;
    width: 10rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    overflow: auto;
}

/* width */
.select-filter::-webkit-scrollbar {
    height: 3px;
}

/* Track */
.select-filter::-webkit-scrollbar-track {
    background: #f1f1f1;
}

/* Handle */
.select-filter::-webkit-scrollbar-thumb {
    background: #888;
}

/* Handle on hover */
.select-filter::-webkit-scrollbar-thumb:hover {
    background: #555;
}

.select-filter i {
    font-size: 1.15rem;
}

.wrap-select-item {
    display: flex;
    gap: 0.5rem;
}

.wrap-summary {
  display: flex;
  justify-content: space-between;
  width: 100%;
  margin-bottom: 2rem;
  gap: 1rem;
}

.summary-data {
  /* box-shadow: 0px 3px 8px 0px rgba(0, 0, 0, 0.2); */
  transition: 0.3s;
  padding: 1rem;
  border-radius: 0.5rem;
  cursor: pointer;
  width: 22%;
  border: solid 1px #dddddd;
}

.summary-data div:last-child {
  float: right;
}

.summary-data div:last-child span:first-child {
  font-size: 1.75rem;
  margin-right: 0.5rem;
  font-weight: bold;
}

.summary-data:hover {
  /* box-shadow: 0 4px 16px 0 rgba(0, 0, 0, 0.2); */
  box-shadow: 0px 3px 8px 0px rgba(0, 0, 0, 0.2);
}

.select-item {
    border: 1px solid #ddd;
    border-radius: 15px;
    padding: 1px 0.5rem;
    white-space: nowrap;
    width: 7rem;
    overflow: hidden;
    text-overflow: ellipsis;
    font-size: 11px;
    position: relative;
    transition: width 1s;
}

.select-item:hover {
    position: absolute;
    top: 9px;
    background-color: #ffff;
    width: 11.5rem;
    min-width: 11.5rem;
    z-index: 1;
    transition: width 1s;
}

.select-close {
    position: absolute;
    right: 0.5rem;
    top: 0.3rem;
    width: 0.5rem;
    cursor: pointer;
}

.refresh-button {
    cursor: pointer;
    color: #2e75b6;
    width: 26%;
}

.btn-filter {
    box-shadow: unset;
    background-color: var(--primary-color);
    color: #ffffff;
    font-size: 14px;
    border-radius: 5px;
}

.wrap-filter-by {
    padding: 1rem;
    display: flex;
    gap: 1rem;
}

.filter-by label:first-child {
    font-weight: bold;
}

.filter-by ul {
    margin: unset;
}

.wrap-sort {
    padding: 1rem;
    width: 16rem;
}

.badge {
    width: 1rem;
    height: 1rem;
    background: #fff;
    color: #2e75b6;
    border-radius: 50%;
    font-size: 0.69rem;
}

.sort-asc-dsc {
    display: flex;
    justify-content: space-around;
    border-bottom: solid 1px #dddddd;
    margin-bottom: 1rem;
}

.icon-close {
    position: absolute;
    right: 1.5rem;
    top: 2.25rem;
    width: 0.75rem;
    cursor: pointer;
}

.icon-sort{
    cursor: pointer;
}

input[type="radio"] {
    margin-right: 0.5rem;
}
.sort-by label {
    font-weight: bold;
    display: block;
}

.sort-by select {
    width: 100%;
}

.top-title {
    display: flex;
    justify-content: space-between;
}

.bagi {
    height: 30px;
}

.sort-date {
    display: flex;
    gap: 1rem;
}

.form-group {
    margin-bottom: unset;
    position: relative;
}

.form-input {
    border: solid 1px var(--clr-scondary);
    height: 2.5rem;
    padding: 5px 10px;
    border-radius: 100px;
    font-size: 12px;
    width: 100%;
}

.form-input:focus{
    outline: none;
}

.form-input::placeholder {
    color: #ccc;
}

/* .bagi-menu {
  background-image: url("../assets/logo_agi.png");
} */

select#revenue option[value="bank"] {
    background-image: url("../../../assets/logo_agi.png");
}

.title-page {
    font-size: 25px;
    font-weight: bold;
    margin-bottom: 40px;
}

.option-table {
    background: #f8f8f8;
    border: none;
    width: 100%;
}

.icon-trade {
    width: 25px;
}

.footer {
    background: var(--primary-color);
    color: white;
    padding: 20px 47px;
    display: flex;
    justify-content: space-between;
    margin-top: auto;
    height: 62px;
}

.wrap-input {
    margin-bottom: 10px;
}
.label-input {
    width: 108px;
}

select {
    border-radius: 3px;
    border-color: #a5a5a5a5;
    padding: 3px;
}

.card {
    width: 314px;
    font-size: 14px;
    border-radius: 10px;
}

.card-header {
    padding: 1rem;
}

.buyer,
.seller,
.card-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.title {
    font-size: 12px;
    position: relative;
    left: 20px;
}

.title::before {
    content: "";
    position: absolute;
    width: 11px;
    height: 11px;
    border-radius: 50%;
    background: var(--scondary-color);
    left: -17px;
    top: 3px;
}

.buyer {
    margin-bottom: 20px;
}

.content-right {
    text-align: right;
}

.amount {
    font-weight: bold;
}

.btn-primer {
    background: var(--scondary-color);
    border: none;
    color: #ffffff;
    padding: 5px 25px;
    border-radius: 5px;
    cursor: pointer;
}

.btn-primer:hover {
    background-color: var(--scondary-color-hover);
}

.button-dropdown {
    width: 100% !important;
}

.dropdown-toggle {
    display: flex;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;
}

.item-dropdown {
    cursor: pointer;
    font-size: 14px;
    text-align: left;
    display: flex;
    gap: 0.6em;
}

.item-dropdown:hover {
    background: #f2f2f2;
}

.btn-group > .btn {
    box-shadow: none;
}

.dropdown-menu {
    width: 100%;
    font-size: 13px;
    transform: translate3d(-30px, 21px, 0px);
}

.dropdown-menu.show {
    transform: translate3d(-30px, 21px, 0px) !important;
}

.dropdown-item {
    cursor: pointer;
    display: flex;
    gap: 0.5rem;
    padding: 0.25rem 0.7rem;
}

.img-revenue {
    height: 15px;
}

.wrap-img {
    width: 33px;
    text-align: center;
}

.wrap-img img {
    height: 15px;
}
</style>
